import { render, staticRenderFns } from "./TrainAdminLayout.vue?vue&type=template&id=40717b1c&scoped=true"
import script from "./TrainAdminLayout.vue?vue&type=script&lang=js"
export * from "./TrainAdminLayout.vue?vue&type=script&lang=js"
import style0 from "./TrainAdminLayout.vue?vue&type=style&index=0&id=40717b1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40717b1c",
  null
  
)

export default component.exports